import React from 'react';
import "./output.css";

// Import components
import {
    Header,
    Settings,
    AddItem,
    ItemList,
    Actions,
    Help
} from './components';

// Import hooks
import { useConfigManager } from './hooks/useConfigManager';
import { useUIState } from './hooks/useUIState';

const App: React.FC = () => {
    const {
        config,
        newItem,
        setNewItem,
        addItem,
        removeItem,
        updateItem,
        moveItemUp,
        moveItemDown,
        updateConfig
    } = useConfigManager();

    const {
        showPreview,
        showSettings,
        showHelp,
        togglePreview,
        toggleSettings,
        toggleHelp
    } = useUIState();

    const handleNewItemChange = (updates: Partial<{ title: string; image: string; url: string }>) => {
        setNewItem(prev => ({ ...prev, ...updates }));
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4" dir="rtl">
            <div className="max-w-5xl mx-auto space-y-6">
                <Header />
                
                <Settings
                    config={config}
                    onConfigUpdate={updateConfig}
                    isOpen={showSettings}
                    onToggle={toggleSettings}
                />

                <AddItem
                    newItem={newItem}
                    onNewItemChange={handleNewItemChange}
                    onAddItem={addItem}
                />

                <ItemList
                    items={config.list}
                    onRemoveItem={removeItem}
                    onUpdateItem={updateItem}
                    onMoveItemUp={moveItemUp}
                    onMoveItemDown={moveItemDown}
                />

                <Actions
                    config={config}
                    showPreview={showPreview}
                    onShowPreviewToggle={togglePreview}
                    onConfigUpdate={updateConfig}
                />

                <Help
                    isOpen={showHelp}
                    onToggle={toggleHelp}
                />
            </div>
        </div>
    );
};

export default App;